import React from 'react';
interface ServicesTabProps {
  services: any[];
  getServiceValue: (service: any, field: string) => any;
  setServiceField: (service: any, field: string, value: any) => void;
  onAdd: () => void;
  onDelete: (service: any) => void;
  onSaveAll: () => void;
  isAdding: boolean;
  isSaving: boolean;
}

const ServicesTab: React.FC<ServicesTabProps> = ({
  services, getServiceValue, setServiceField,
  onAdd, onDelete, onSaveAll, isAdding, isSaving,
}) => (
  <div className="space-y-6">
    <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
      <h3 className="font-semibold text-blue-900 mb-2">Services Management</h3>
      <p className="text-sm text-blue-800">Manage services displayed on the website</p>
    </div>

    <div className="flex justify-end mb-4">
      <button onClick={onAdd} disabled={isAdding} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50">
        {isAdding ? 'Adding...' : '+ Add Service'}
      </button>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {services.map((service: any) => (
        <div key={service.documentId || service.id} className="border border-gray-200 rounded-lg p-4 bg-white">
          <div className="flex justify-between items-start mb-3">
            <span className="text-2xl">{getServiceValue(service, 'icon')}</span>
            <button onClick={() => onDelete(service)} className="text-red-600 hover:text-red-800">🗑️</button>
          </div>
          <div className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Icon</label>
              <input type="text" value={getServiceValue(service, 'icon')} onChange={(e) => setServiceField(service, 'icon', e.target.value)} className="w-full px-2 py-1 text-sm border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Title</label>
              <input type="text" value={getServiceValue(service, 'title')} onChange={(e) => setServiceField(service, 'title', e.target.value)} className="w-full px-2 py-1 text-sm border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Description</label>
              <textarea value={getServiceValue(service, 'description')} onChange={(e) => setServiceField(service, 'description', e.target.value)} rows={3} className="w-full px-2 py-1 text-sm border border-gray-300 rounded" />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Order</label>
                <input type="number" value={getServiceValue(service, 'displayOrder')} onChange={(e) => setServiceField(service, 'displayOrder', parseInt(e.target.value))} className="w-20 px-2 py-1 text-sm border border-gray-300 rounded" />
              </div>
              <div className="flex items-center">
                <input type="checkbox" checked={getServiceValue(service, 'isActive')} onChange={(e) => setServiceField(service, 'isActive', e.target.checked)} className="h-4 w-4 text-blue-600" />
                <label className="ml-2 text-xs text-gray-700">Active</label>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="flex justify-end pt-4 border-t">
      <button onClick={onSaveAll} disabled={isSaving} className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50">
        {isSaving ? 'Saving...' : 'Save All Services'}
      </button>
    </div>
  </div>
);

export default ServicesTab;
